import React, { useState, useEffect } from "react";
import api from "../services/api";

export default function Rapports() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/rapports/stats").then(r => setStats(r.data)); }, []);
  const STATUTS = { actif:"#28a745", inactif:"#6c757d", maintenance:"#F5A800", reforme:"#dc3545" };
  return (
    <div style={{ padding:32 }}>
      <h1 style={{ fontSize:24, fontWeight:800, color:"#1B3A8C", marginBottom:32 }}>Rapports</h1>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px,1fr))", gap:20 }}>
        <div style={{ background:"#fff", borderRadius:12, padding:24, boxShadow:"0 2px 12px rgba(0,0,0,0.08)", gridColumn:"1/-1" }}>
          <h3 style={{ color:"#1B3A8C", marginBottom:16 }}>Répartition par statut</h3>
          <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
            {(stats?.parStatut||[]).map(s => (
              <div key={s.statut} style={{ background:STATUTS[s.statut]+"22", border:`2px solid ${STATUTS[s.statut]}`, borderRadius:12, padding:"16px 24px", textAlign:"center" }}>
                <div style={{ fontSize:28, fontWeight:800, color:STATUTS[s.statut] }}>{s.count}</div>
                <div style={{ fontSize:13, color:STATUTS[s.statut], fontWeight:700, textTransform:"capitalize" }}>{s.statut}</div>
              </div>
            ))}
          </div>
        </div>
        {(stats?.parCategorie||[]).map(c => (
          <div key={c.categorieId} style={{ background:"#fff", borderRadius:12, padding:20, boxShadow:"0 2px 12px rgba(0,0,0,0.08)", borderLeft:`4px solid ${c.Categorie?.couleur||"#1B3A8C"}` }}>
            <div style={{ fontSize:24, fontWeight:800, color:c.Categorie?.couleur||"#1B3A8C" }}>{c.count}</div>
            <div style={{ fontSize:14, color:"#333", marginTop:4 }}>{c.Categorie?.nom||"Sans catégorie"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
